import { render, staticRenderFns } from "./AwardBoxCreatePopup.vue?vue&type=template&id=17273355&"
import script from "./AwardBoxCreatePopup.vue?vue&type=script&lang=ts&"
export * from "./AwardBoxCreatePopup.vue?vue&type=script&lang=ts&"
import style0 from "./AwardBoxCreatePopup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports